import { confirmDialog } from "@/dialogs/ConfirmDialog";
import { Composer } from "vue-i18n";
import { Api } from "@superagent-dev/superagent-rest-api-client";
import { useConversation } from "@/composables/conversation";
import { useApp } from "@/composables/use-app";
import { useChatConnection } from "@/composables/chatConnection";

export function useFileUploader(t: Composer["t"]) {
  const { conversation } = useConversation();
  const { widgetId, visitorId, isPreviewMode } = useApp();
  const { sendFiles } = useChatConnection();

  const api = new Api({
    baseUrl: process.env.VUE_APP_REST_BASEURL as string,
  });

  const initUpload = async (fileName: string) => {
    if (!conversation.value?.id) {
      console.warn("conversation id not available");
      return;
    }

    if (!widgetId.value) {
      console.warn("widget id not available");
      return;
    }

    if (!visitorId.value) {
      console.warn("visitor id not available");
      return;
    }

    return await api.chat.attachmentInitPost({
      conversationId: conversation.value?.id,
      widgetId: widgetId.value,
      visitorId: visitorId.value,
      fileName,
    });
  };

  const uploadFiles = async (files: File[]) => {
    if (files.length > 10) {
      alert(t("attachments.maxNumberOfFilesExceeded", { count: 10 }));
      return;
    }

    if (
      !(await confirmDialog(
        t("attachments.confirmDialogHeader"),
        t("attachments.confirmDialogTextFilesSelected"),
        t("shared.confirm"),
        t("shared.cancel")
      ))
    ) {
      return;
    }

    if (isPreviewMode.value) {
      console.log("Preview mode, aborting");
      return;
    }

    const combined: { fileName: string; fileId: string }[] = [];

    for (const file of files) {
      const initResult = await initUpload(file.name);

      if (
        !initResult?.ok ||
        !initResult?.data.success ||
        !initResult.data.preSignedUrl ||
        !initResult.data.fileId
      ) {
        console.log("Attachment init was non-success", initResult);
        continue;
      }

      const request = new Request(initResult.data.preSignedUrl, {
        body: file,
        method: "PUT",
      });

      const upload = await fetch(request);

      if (!upload.ok) {
        console.warn(upload);
        console.warn("Could not upload file to S3", file);
        continue;
      }

      combined.push({
        fileId: initResult.data.fileId,
        fileName: file.name,
      });
    }

    sendFiles(combined);

    // const finalizeResult = sendFiles(
    //   file.name,
    //   initResult.data.fileId
    // );
    //
    // if (!finalizeResult?.ok || !finalizeResult.data.success) {
    //   console.warn("Attachment finalization failed", finalizeResult);
    // }
  };

  return {
    uploadFiles,
  };
}
